// Resolve a backend file/asset URL.
//
// The backend serves uploaded files from the API root (e.g. `/uploads/foo.pdf`),
// NOT under the `/api/v1` prefix. `VITE_API_BASE_URL` typically points at the
// versioned API root (e.g. `https://api.podus.ai/api/v1`); we strip the
// `/api/vN` segment so static asset paths resolve against the host instead.

const RAW_BASE = (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? '/api/v1';
const API_ROOT = RAW_BASE.replace(/\/+$/, '').replace(/\/api\/v\d+$/i, '');

export const BACKEND_BASE_URL = API_ROOT;

export function resolveFileUrl(url: string | null | undefined): string {
  if (!url) return '';
  // Already absolute, blob, data URL, or protocol-relative — leave as-is.
  if (/^(https?:|data:|blob:|\/\/)/i.test(url)) return url;
  // Relative path → prefix with backend root.
  if (url.startsWith('/')) return `${API_ROOT}${url}`;
  return `${API_ROOT}/${url}`;
}
